import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Modal, Field, SaButton, sa, errMsg } from './ui';

export const ImpersonateModal = ({ company, onClose }) => {
  const [reason, setReason] = useState('');
  const [busy, setBusy] = useState(false);

  const start = async (e) => {
    e.preventDefault();
    if (reason.trim().length < 5) return toast.error('Please enter a reason (at least 5 characters)');
    setBusy(true);
    try {
      const { data } = await axios.post(`/superadmin/companies/${company.id}/impersonate`, { reason: reason.trim() });
      localStorage.setItem('superadmin_token', localStorage.getItem('token'));
      localStorage.setItem('token', data.token);
      window.location.href = '/';
    } catch (err) {
      toast.error(errMsg(err, 'Could not start impersonation'));
      setBusy(false);
    }
  };

  return (
    <Modal title={`Impersonate ${company.name}`} onClose={onClose} testId="impersonate-modal">
      <p style={{ color: '#A1A1AA', fontSize: 14, marginTop: 0, marginBottom: 16, lineHeight: 1.5 }}>
        You will act as a <strong style={{ color: '#fff' }}>company admin</strong> of {company.name} for up to 60 minutes.
        Every change you make is recorded in the audit log together with your reason.
      </p>
      <form onSubmit={start}>
        <Field label="Reason for this support session (required)">
          <textarea
            data-testid="impersonate-reason-input"
            style={{ ...sa.input, minHeight: 90, resize: 'vertical' }}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder="e.g. Ticket #482 — customer reports proposal totals not updating"
            autoFocus
          />
        </Field>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
          <SaButton variant="ghost" onClick={onClose}>Cancel</SaButton>
          <SaButton data-testid="impersonate-start-btn" type="submit" disabled={busy}>{busy ? 'Starting…' : 'Start impersonation'}</SaButton>
        </div>
      </form>
    </Modal>
  );
};
